import React, { useState, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { Tabs, Col, Select, Button, Row } from 'antd';
import {
  FaUserCircle,
  FaCreditCard,
  FaCog,
  FaStar,
  FaCaretDown,
  FaPen,
} from 'react-icons/fa';

import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUserState } from '../../../store/user/selector';
import { ProfileLocation } from './ProfileContents';
import { RatingsContent } from './Ratings';
import { MealSummary } from './Meals';
import { SettingsMenu } from '../../settings/components/SettingsMenu';
import { ProfileMenu } from './ProfileMenu';
import { changeAccountType } from '../../../store/settings/actions';
import { DropdownSelect } from '../../layout/PageHeader';

const COOK = 'Cook';
const GUEST = 'Guest';

export const ProfileContent = () => {
  const { user, ratings } = useSelector(getUserState);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history: History = useHistory();
  const { address } = user;
  const [windowWidth, setWindowWidth] = useState(0);
  const isDesktop = windowWidth >= 768;
  const handleSwitchAccountType = () => {
    if (window.confirm('Are you sure you want to switch account?')) {
      dispatch(changeAccountType());
    }
  };

  const handleEditButton = () => history.push('profile/edit');

  const handleChangeAccountType = () => {
    const userState = {
      accountType: user.accountType === 'cook' ? 'guest' : 'cook',
      address: user.address,
      authComplete: user.authComplete,
      description: user.description,
      email: user.email,
      firstName: user.firstName,
      image: user.image,
      lastName: user.lastName,
      phone: user.phone,
      status: user.status,
      userid: user.userid,
      username: user.username,
    };
    if (
      window.confirm(
        `Are you sure you want to become a ${
          user.accountType === 'cook' ? 'Guest' : 'Cook'
        }?`
      )
    ) {
      history.push({
        pathname: '/profile/update',
        state: userState,
      });
      // dispatch(changeAccountType());
    }
  };
  useLayoutEffect(() => {
    const updateSize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.addEventListener('resize', updateSize);
  }, []);
  const checklength = ratings.filter(item => item.user === user.userid);
  const rate = ratings
    .filter(v => v.user === user.userid)
    .reduce((a, b) => a + b.rate / checklength.length, 0);
  return (
    <Col className="">
      <Col
        className="create-profile-container profile-photo"
        style={{
          backgroundImage: `url(${user.image})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      ></Col>
      <Col className="profile-info">
        <span>{user.firstName}</span>
        <span className="profile-rating">
          <FaStar color="#F7C82E" size={14} style={{ marginRight: 5 }} />
          {rate !== 0 ? rate : 'No Ratings'}
        </span>
      </Col>
      <Col className="profile-description profile-selection">
        <Select
          value={user.accountType === 'cook' ? COOK : GUEST}
          style={{ width: 140, height: 36, borderRadius: 9 }}
          suffixIcon={<FaCaretDown />}
          onChange={
            user.subAccountType === ''
              ? handleChangeAccountType
              : handleSwitchAccountType
          }
        >
          <Select.Option value={GUEST}>{t('I_AM_GUEST')}</Select.Option>
          <Select.Option value={COOK}>{t('I_AM_COOK')}</Select.Option>
        </Select>

        {!isDesktop && <DropdownSelect />}
      </Col>
      {user.accountType === COOK.toLowerCase() && address && (
        <ProfileLocation location={address} />
      )}

      <Col
        xs={24}
        sm={24}
        md={18}
        lg={18}
        xl={18}
        className="profile-description"
      >
        {user.description}
      </Col>
      <Col className="profile-edit primary-button-basic-container">
        {(user.subAccountType === '' || user.subAccountType === undefined) &&
        !isDesktop ? (
          <Button
            type="primary"
            shape="round"
            className="primary-button-basic profile-button"
            onClick={handleChangeAccountType}
          >
            {t(`Became a ${user.accountType === 'cook' ? GUEST : COOK}`)}
          </Button>
        ) : null}
        <Button type="link" onClick={handleEditButton}>
          <FaPen /> {t('Edit Profile')}
        </Button>
      </Col>
      <RatingsContent />
      <MealSummary />

      {!isDesktop && <ProfileMenu />}
    </Col>
  );
};

export const ProfileTabs: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');
  const { t } = useTranslation();
  const windorResizeListener = () => {
    if (window.innerWidth <= 768) {
      setActiveKey('1');
    }
  };
  window.addEventListener('resize', windorResizeListener);

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs
      defaultActiveKey="1"
      activeKey={activeKey}
      onTabClick={onTabClick}
      className="profile-tabs-container"
      size="large"
    >
      <Tabs.TabPane
        tab={
          <Row className="tab-text">
            <FaUserCircle size={17} />
            <span>{t('Profile')}</span>
          </Row>
        }
        key="1"
      >
        <ProfileContent />
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <Row className="tab-text">
            <FaCreditCard size={17} />
            <span>{t('Payment Card')}</span>
          </Row>
        }
        key="2"
      >
        Payment Card
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <Row className="tab-text">
            <FaCog size={17} />
            <span>{t('Settings')}</span>
          </Row>
        }
        key="3"
      >
        <Col span={22} offset={1}>
          <SettingsMenu />
        </Col>
      </Tabs.TabPane>
    </Tabs>
  );
};
